export default {
  methods: {
    enter: function (element) {
      const height = window.getComputedStyle(element).height

      element.style.height = height
      element.style.position = "absolute"
      element.style.visibility = "hidden"
      element.style.width = "auto"
      element.style.left = 0

      const width = window.getComputedStyle(element).width

      element.style.height = null
      element.style.position = null
      element.style.visibility = null
      element.style.width = 0

      setTimeout(() => {
        element.style.width = width
      })
    },
    afterEnter(element) {
      element.style.width = "auto"
    },
    leave(element) {
      const width = window.getComputedStyle(element).width

      element.style.width = width

      setTimeout(() => {
        element.style.width = 0
      })
    },
  },
}
